import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer } from '../ui/Drawer';
import { NotificationItem } from './NotificationItem';
import {
  useNotifications,
  useMarkAsRead,
  useMarkAllAsRead,
  useDeleteNotification,
} from '../../hooks/useNotifications';
import type { AppNotification } from '../../api/types';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function NotificationDrawer({ open, onClose }: Props) {
  const navigate = useNavigate();
  const { data, isLoading } = useNotifications(1);
  const markRead = useMarkAsRead();
  const markAllRead = useMarkAllAsRead();
  const del = useDeleteNotification();

  const notifications = data?.data ?? [];

  const handleClick = (n: AppNotification) => {
    if (!n.isRead) markRead.mutate(n.id);
    if (n.link) navigate(n.link);
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Notifiche"
      width={420}
      footer={notifications.length > 0 ? (
        <button
          onClick={() => markAllRead.mutate()}
          disabled={markAllRead.isPending}
          style={{
            padding: '0.5rem 1rem',
            background: 'var(--color-primary)',
            color: '#fff',
            border: 'none',
            borderRadius: 'var(--radius-card)',
            cursor: 'pointer',
            fontSize: 'var(--text-sm)',
            width: '100%',
          }}
        >
          Segna tutte come lette
        </button>
      ) : undefined}
    >
      {isLoading ? (
        <p style={{ color: 'var(--color-text-faint)', textAlign: 'center', padding: '2rem 0' }}>Caricamento...</p>
      ) : notifications.length === 0 ? (
        <p style={{ color: 'var(--color-text-faint)', textAlign: 'center', padding: '2rem 0' }}>Nessuna notifica</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
          {notifications.map(n => (
            <NotificationItem
              key={n.id}
              notification={n}
              onMarkRead={id => markRead.mutate(id)}
              onDelete={id => del.mutate(id)}
              onClick={handleClick}
            />
          ))}
        </div>
      )}
    </Drawer>
  );
}
